export enum TransactionModel {
    C2B,
    WAYYAK,
    PAYMENTLINK,
    COUPON
}